// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"jgp-u7ghm","icon":"jgp-1ncA1"};